import { useState, useEffect } from 'react';
import {
  ProgressBar as BProgressBar,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  FormLabel,
  FormControl,
  Button,
  Alert,
} from 'react-bootstrap';
import '../../styles/ProgressBarComponente.css';
import { Box, TextField, Button as MuiButton } from '@material-ui/core';
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks';
import FormularioService from '../../API/FormularioService';
import ProgressCircle from '../atoms/ProgressCircle';
import { DenunciaComments } from './DenunciaComments';
import { pushAdminComment } from '../../redux/foil/foilSlice';

const ProgressBarComponente = ({ catalogs }) => {
  const dispatch = useAppDispatch();
  const { foilCode, foilData, foilKey } = useAppSelector(({ foilReducer }) => foilReducer);
  const [responseData, setResponseData] = useState({});

  const { isLogged } = useAppSelector(({ adminReducer }) => adminReducer);
  const [IdEstatusDenuncia, setIdEstatusDenuncia] = useState(responseData?.idEstatusDenuncia || 2);
  const [selectedEstatusDenuncia, setSelectedEstatusDenuncia] = useState(responseData?.estatusDenuncia); // numero

  const [note, setNote] = useState('');
  const currentStep = responseData?.idEstatusDenuncia || '1';

  //  Cambia el comentario
  const handleSaveNote = () => {
    const updateEstatusObject = {
      dispatch,
      folio: foilCode,
      idEstatusDenuncia: IdEstatusDenuncia,
      estatusDenuncia: selectedEstatusDenuncia,
    };

    FormularioService.updateEstatusDenuncia(updateEstatusObject).then(response => {
      setResponseData(response);
      setSelectedEstatusDenuncia(response.estatusDenuncia);
    });
  };

  const saveButton =
    IdEstatusDenuncia === 2 || IdEstatusDenuncia === 3 ? (
      <Button variant="primary" className="btn btn-truper" onClick={handleSaveNote}>
        Guardar
      </Button>
    ) : null;

  const onSendComment = async () => {
    if (note.trim() === '') return;

    try {
      const resp = await FormularioService.sendAdminComment({
        dispatch,
        idDenuncia: foilData.idFolio,
        comentario: note,
      });

      pushAdminComment(dispatch, resp);
      setNote('');
    } catch (error) {
      console.error('Error al enviar el comentario:', error);
    }
  };

  useEffect(() => {
    setResponseData(foilData);
  }, [foilData]);

  return (
    <>
      <h1>Estado de la solicitud</h1>
      <Container className="m-6 p-4 contenedorStatus">
        <Row className="circulos">
          <div className=" col-md-offset-1">
            <ProgressCircle currentStep={currentStep} index={0} isCurrentStep={currentStep === 1} />
            <p className="status">Recibida</p>
          </div>
          <div className=" col-xs-offset-1">
            <ProgressCircle currentStep={currentStep} index={1} isCurrentStep={currentStep === 2} />
            <p className="status">En revisión</p>
          </div>
          <div className=" col-xs-offset-1">
            <ProgressCircle currentStep={currentStep} index={2} isCurrentStep={currentStep === 3} />
            <p className="status">Finalizada</p>
          </div>
        </Row>
        <Row className="linea">
          <Col md={12} style={{ display: 'flex', justifyContent: 'center' }}>
            <BProgressBar
              animated={!(currentStep > 2)}
              className="barra"
              variant="success"
              now={100 * (currentStep / 3)}
              label={` ${currentStep} `}
            />
          </Col>
        </Row>
      </Container>
      <Container className="m-6 p-4 contenedorFormulario">
        {isLogged ? (
          <Form onSubmit={handleSaveNote}>
            <FormGroup>
              <div>
                <FormLabel>
                  {foilData.idEstatusDenuncia <= 2 && responseData?.idEstatusDenuncia !== 3 ? <strong>Selecciona un estatus para la denuncia</strong> : ''}
                </FormLabel>
                {responseData?.idEstatusDenuncia !== 3 ? (
                  <FormControl
                    as="select"
                    value={IdEstatusDenuncia}
                    onChange={event => setIdEstatusDenuncia(Number(event.target.value))}
                  >
                    <option value={2}>En proceso</option>
                    <option value={3}>Cerrada</option>
                  </FormControl>
                ) : (
                  ''
                )}
              </div>
            </FormGroup>
            {(IdEstatusDenuncia === 2 || IdEstatusDenuncia === 3) && responseData?.idEstatusDenuncia !== 3 ? <FormGroup>{saveButton}</FormGroup> : null}
          </Form>
        ) : (
          <></>
        )}
        {foilData?.comentarios && Array.isArray(foilData.comentarios) ? (
          <>
            <DenunciaComments
              comments={foilData.comentarios || []}
              denunciaNumber={foilCode}
              password={foilKey || ''}
              fechaCreacion={foilData.fechaCreacion}
            />
            {(IdEstatusDenuncia === 2 || IdEstatusDenuncia === 3) && selectedEstatusDenuncia !== 'Cerrada' && (
              <Box
                mt={4}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 10,
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                }}
              >
                <TextField
                  minRows={4}
                  maxRows={4}
                  multiline
                  fullWidth
                  placeholder="Agrega un comentario"
                  variant="outlined"
                  value={note}
                  onChange={e => setNote(e.target.value)}
                />
                <MuiButton color="primary" variant="contained" disableElevation onClick={onSendComment}>
                  Enviar comentario
                </MuiButton>
              </Box>
            )}
          </>
        ) : (
          <Alert variant="success">
            <Alert.Heading>Comentarios</Alert.Heading>
            <p>{responseData?.comentarios || ''}</p>
          </Alert>
        )}
      </Container>
    </>
  );
};

export default ProgressBarComponente;
